(function () {
    'use strict';

    angular
        .module('atheer.services')
        .factory('SessionLastActive', SessionLastActive);

    /*
     * Mirrors ibm-frontend `sessionLastActive.ts`. The `last-active-time`
     * localStorage key is shared between fos-web and ibm-frontend on the
     * same origin so the two apps share a single idle clock and so a
     * sign-out in one app cleans the timestamp for the other.
     */

    /* @ngInject */
    function SessionLastActive($window) {
        var AUTH_STORAGE_KEY = 'Authorization';
        var SESSION_LAST_ACTIVE_AT_KEY = 'last-active-time';
        var LEGACY_SESSION_LAST_ACTIVE_AT_KEY = 'last_active_time';
        var MIN_SESSION_IDLE_TIMEOUT_MS = 60 * 1000;

        return {
            AUTH_STORAGE_KEY: AUTH_STORAGE_KEY,
            SESSION_LAST_ACTIVE_AT_KEY: SESSION_LAST_ACTIVE_AT_KEY,
            MIN_SESSION_IDLE_TIMEOUT_MS: MIN_SESSION_IDLE_TIMEOUT_MS,
            readSessionLastActiveAt: readSessionLastActiveAt,
            writeSessionLastActiveAt: writeSessionLastActiveAt,
            clearStoredAuth: clearStoredAuth,
            getSessionIdleTimeoutMs: getSessionIdleTimeoutMs,
            isWarningEnabled: isWarningEnabled,
            isLastActivePastIdleLimit: isLastActivePastIdleLimit
        };

        function readSessionLastActiveAt() {
            try {
                var raw = $window.localStorage.getItem(SESSION_LAST_ACTIVE_AT_KEY);
                if (raw == null || raw === '') {
                    return null;
                }
                var n = parseInt(raw, 10);
                return isFinite(n) ? n : null;
            } catch (e) {
                return null;
            }
        }

        function writeSessionLastActiveAt(timestampMs) {
            var ts = (typeof timestampMs === 'number' && isFinite(timestampMs))
                ? timestampMs
                : Date.now();
            try {
                $window.localStorage.setItem(SESSION_LAST_ACTIVE_AT_KEY, String(ts));
            } catch (e) {
                // ignore: storage may be unavailable (e.g. private mode quota)
            }
        }

        function clearStoredAuth() {
            try {
                $window.localStorage.removeItem(AUTH_STORAGE_KEY);
                $window.localStorage.removeItem(SESSION_LAST_ACTIVE_AT_KEY);
                $window.localStorage.removeItem(LEGACY_SESSION_LAST_ACTIVE_AT_KEY);
            } catch (e) {
                // ignore
            }
        }

        /*
         * Idle duration (ms) when auto sign-out is enabled and wait minutes are
         * valid (> 0). Returns null when disabled or misconfigured so callers
         * can skip starting any timer (no hidden fallback).
         */
        function getSessionIdleTimeoutMs(authSetupFields) {
            if (!authSetupFields || !angular.isArray(authSetupFields)) {
                return null;
            }
            var enabledField = findFieldByName(authSetupFields, 'auto_signout_enabled');
            if (!enabledField || !isTruthyString(enabledField.value)) {
                return null;
            }
            var minsField = findFieldByName(authSetupFields, 'auto_signout_wait_time_mins');
            var waitMins = parseInt(minsField && minsField.value, 10);
            if (!isFinite(waitMins) || waitMins <= 0) {
                return null;
            }
            return Math.max(waitMins * 60 * 1000, MIN_SESSION_IDLE_TIMEOUT_MS);
        }

        function isWarningEnabled(authSetupFields) {
            if (!authSetupFields || !angular.isArray(authSetupFields)) {
                return false;
            }
            var warningField = findFieldByName(authSetupFields, 'auto_signout_show_warning');
            return !!(warningField && isTruthyString(warningField.value));
        }

        /*
         * Workspace settings can store boolean-ish flags as either "true"
         * or "1" depending on which UI saved them. Treat both as truthy.
         */
        function isTruthyString(value) {
            if (value == null) {
                return false;
            }
            var v = String(value).toLowerCase().trim();
            return v === 'true' || v === '1' || v === 'yes';
        }

        function isLastActivePastIdleLimit(lastActiveAt, idleTimeoutMs, nowMs) {
            if (lastActiveAt == null) {
                return false;
            }
            var now = (typeof nowMs === 'number' && isFinite(nowMs)) ? nowMs : Date.now();
            return now - lastActiveAt > idleTimeoutMs;
        }

        function findFieldByName(fields, name) {
            for (var i = 0; i < fields.length; i++) {
                if (fields[i] && fields[i].name === name) {
                    return fields[i];
                }
            }
            return null;
        }
    }
})();
